import { LanguageCode } from "@bto/shared";
import {
  RevealGenderEmailSerializer,
  ShareFetalSexEmailSerializer,
} from "../../../recoil/types";
import { BASE_URL } from "../../../utils/requestUtils";
import { PatientReviewRequestPayload } from "../types";

// Response body for the multi-recipient share endpoint. HTTP 201 means every
// email was sent, 207 means a partial success (both lists populated).
export interface ShareFetalSexEmailResponse {
  sent_emails: string[];
  failed_emails: string[];
}

export const ShareFetalSexEmailRequest = async (
  shareInfo: ShareFetalSexEmailSerializer,
  access_token?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/standalone_fetal_sex/gender_reveal`, {
    body: JSON.stringify(shareInfo),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
  });

// TODO(SFS_FLAG_CLEANUP): Remove this legacy aneuploidy-backed request with
// the restored flag-off forward flow.
export const ForwardFetalSexEmailRequest = async (
  revealInfo: RevealGenderEmailSerializer,
  access_token?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/gender_reveal`, {
    body: JSON.stringify(revealInfo),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
  });

export const ReportDownloadRequest = async (
  reportID: string,
  type: "carrier" | "aneuploidy" | "cfc",
  access_token?: string,
  language?: LanguageCode,
): Promise<Response> => {
  let reportPath = "unity";
  if (type === "aneuploidy") {
    reportPath = "aneuploidy";
  }
  if (type === "cfc") {
    reportPath = "cfc";
  }
  const languageParam = language ? `language=${language}&` : "";
  return fetch(
    `${BASE_URL}/api/v1/${reportPath}reports/${reportID}/download/?${languageParam}download_location=patient_${reportPath}_report_page`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    },
  );
};

export const GetPatientReviewRequest = async (
  access_token?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/patient_review/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
  });

export const CreatePatientReviewRequest = async (
  createPatientReviewPayload: PatientReviewRequestPayload,
  access_token?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/patient_review/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
    body: JSON.stringify(createPatientReviewPayload),
  });

export const UpdatePatientReviewRequest = async (
  patientReviewID: string,
  updatePatientReviewPayload: PatientReviewRequestPayload,
  access_token?: string,
): Promise<Response> =>
  fetch(`${BASE_URL}/api/v1/patient_review/${patientReviewID}/`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
    body: JSON.stringify(updatePatientReviewPayload),
  });
